import { render, staticRenderFns } from "./laowu-pro-audit.vue?vue&type=template&id=634f7237&scoped=true"
import script from "./laowu-pro-audit.vue?vue&type=script&lang=js"
export * from "./laowu-pro-audit.vue?vue&type=script&lang=js"
import style0 from "./laowu-pro-audit.vue?vue&type=style&index=0&id=634f7237&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "634f7237",
  null
  
)

export default component.exports